import { IChartData } from './interfaces';

import { datasetOptions } from './constants';

export const prepareHistoryCheckChartData = (chartData: IChartData[]) => {
	return {
		labels: chartData.map((item) => item.date),
		datasets: [
			{
				data: chartData.map((item) => item.value),
				...datasetOptions,
			},
		],
	};
};

